import { useNavigate } from "react-router-dom";
import { ExternalLink, Shield } from "lucide-react";
import { COMPANY_INFO } from "@/lib/companyInfo";
import { reopenBanner } from "@/lib/consent";

const AppFooter = () => {
  const navigate = useNavigate();

  const footerLinks = [
    { label: "Termeni și Condiții", path: "/terms" },
    { label: "Confidențialitate", path: "/privacy" },
    { label: "Contact", path: "/contact" },
  ];

  const anpcBadges = [
    {
      label: "ANPC — SAL",
      sublabel: "Soluționarea Alternativă a Litigiilor",
      href: "https://anpc.ro/ce-este-sal/",
    },
    {
      label: "ANPC — SOL",
      sublabel: "Soluționarea Online a Litigiilor",
      href: "https://ec.europa.eu/consumers/odr",
    },
  ];

  return (
    <footer className="py-10 px-4 border-t border-border">
      <div className="container flex flex-col gap-8">
        {/* Top row: brand + nav + copyright */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-6">
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              navigate("/");
            }}
            className="font-heading font-bold text-primary hover:opacity-80 transition-opacity cursor-pointer"
          >
            {COMPANY_INFO.brandName}
          </a>
          <nav className="flex items-center gap-4 sm:gap-6 flex-wrap justify-center">
            {footerLinks.map((link) => (
              <a
                key={link.path}
                href={link.path}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(link.path);
                }}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                {link.label}
              </a>
            ))}
            <button
              type="button"
              onClick={() => reopenBanner()}
              className="text-sm text-muted-foreground hover:text-primary transition-colors"
            >
              Cookie-uri
            </button>
          </nav>
          <p className="text-sm text-muted-foreground">
            © {COMPANY_INFO.copyrightYear} {COMPANY_INFO.brandName}. Toate drepturile rezervate.
          </p>
        </div>

        {/* ANPC badges row — required for B2C in Romania */}
        <div className="flex flex-col items-center gap-3 pt-6 border-t border-border/50">
          <p className="text-xs text-muted-foreground uppercase tracking-wider">
            Protecția Consumatorului
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {anpcBadges.map((badge) => (
              <a
                key={badge.href}
                href={badge.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-3 px-4 py-2.5 rounded-md border border-border bg-card hover:border-primary hover:bg-card/80 transition-all"
              >
                <Shield className="h-5 w-5 text-primary shrink-0" />
                <div className="flex flex-col items-start">
                  <span className="text-sm font-semibold text-foreground group-hover:text-primary transition-colors">
                    {badge.label}
                  </span>
                  <span className="text-[11px] text-muted-foreground leading-tight">
                    {badge.sublabel}
                  </span>
                </div>
                <ExternalLink className="h-3.5 w-3.5 text-muted-foreground group-hover:text-primary transition-colors shrink-0" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
